import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Person from '@material-ui/icons/Person';
import Assignment from '@material-ui/icons/Assignment';
import AssignmentInd from '@material-ui/icons/AssignmentInd';
import CustomIcon from 'components/Icons';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import moment from 'moment';
import { dollars } from "utils/money";

const styles = theme => ({
  root: {
    width: '100%',
  },
  button: {
    marginRight: theme.spacing.unit,
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  content: {
    maxWidth: '400px',
    margin: 'auto'
  },
  btnGroup: {
    display: 'flex',
    justifyContent: 'space-evenly'
  },
  success: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  cardView: {
    display: 'flex',
    justifyContent: 'center'
  },
  card: {
    minWidth: '500px',
    maxWidth: '800px',
  },
  listKey: {
    color: theme.palette.lightGrey,
    width: '120px',
    fontSize: '14px'
  }
});

class Show extends React.Component {
  renderTable = () => {
    const { application } = this.props;
    return (
      <div>
        <List>
          <ListItem>
            <ListItemIcon>
              <CustomIcon icon={<Person color='primary' />} text='Custom Details'/>
            </ListItemIcon>
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Company" />
            <ListItemText primary={application.form.businessName} />
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Name" />
            <ListItemText primary={application.form.name} />
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Email" />
            <ListItemText primary={application.form.contactEmail} />
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Mobile" />
            <ListItemText primary={application.form.contactNumber} />
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Industry" />
            <ListItemText primary={application.form.industry} />
          </ListItem>
        </List>
        <Divider />
        <List>
          <ListItem>
            <ListItemIcon>
              <CustomIcon icon={<Assignment color='primary' />} text='Loan Details'/>
            </ListItemIcon>
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Amount" />
            <ListItemText primary={dollars(application.form.amount)} />
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Term Length" />
            <ListItemText primary={application.form.termLength} />
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Term Unit" />
            <ListItemText primary={application.form.termUnit} />
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Frequency" />
            <ListItemText primary={application.form.frequency} />
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Drawdown Date" />
            <ListItemText primary={moment(application.form.drawdownDate).format('DD/MM/YYYY')} />
          </ListItem>
        </List>
        <Divider />
        <List>
          <ListItem>
            <ListItemIcon>
              <CustomIcon icon={<AssignmentInd color='primary' />} text='Application Details'/>
            </ListItemIcon>
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Number" />
            <ListItemText primary={application.number} />
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Status" />
            <ListItemText primary={application.status} />
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Lodgement Date" />
            <ListItemText primary={application.lodgedAt && moment(application.lodgedAt).format('DD/MM/YYYY')} />
          </ListItem>
        </List>
        <Divider />
      </div>
    );
  }
  render() {
    const { classes } = this.props;

    if (!this.props.application) {
      return null;
    }

    return (
      <div className={this.props.classes.root}>
        <div className={classes.cardView}>
          <Card className={classes.card}>
            <CardContent>
              { this.renderTable() }
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }
}

Show.propTypes = {
  classes: PropTypes.object,
};

const styled = withStyles(styles)(Show)
export default styled;



// WEBPACK FOOTER //
// ./src/components/Leads/Show.js